import { Reveal, SectionHead } from "./Reveal";
import { Zap } from "lucide-react";

const STEPS = [
  ["Requirement", "Tell us about your business and what you need."],
  ["Plan", "We understand your business, audience and goals."],
  ["Design", "We create the website structure and visual experience."],
  ["Develop", "We build the responsive website and required functionality."],
  ["Launch", "Your website goes live."],
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative overflow-hidden bg-obsidian py-24 md:py-32">
    <div className="pointer-events-none absolute left-1/2 top-0 h-[30vh] w-[60vw] -translate-x-1/2 rounded-full bg-royal/10 blur-[120px]" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <SectionHead center eyebrow="Process" title="From idea to live website." />
      <div className="relative mt-16">
        <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-accent/40 to-transparent lg:block" />
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
          {STEPS.map(([title, desc], i) => (
            <Reveal key={title} delay={i * 0.1}>
              <div className="relative text-center" data-testid={`process-step-${i + 1}`}>
                <div className="relative z-10 mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-accent/40 bg-ink font-display text-sm font-black text-accent shadow-[0_0_25px_rgba(0,229,255,0.15)]">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-5 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-white">{title}</h3>
                <p className="mx-auto mt-2 max-w-[220px] text-xs leading-relaxed text-zinc-500">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.3}>
        <div className="mx-auto mt-16 flex w-fit items-center gap-2.5 rounded-full border border-accent/30 bg-accent/5 px-6 py-3" data-testid="process-fasttrack-badge">
          <Zap className="h-4 w-4 text-accent" />
          <span className="font-display text-[10px] font-bold uppercase tracking-[0.2em] text-accent md:text-xs">
            24-Hour Fast Track available for eligible standard projects
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
